import { useCallback } from 'react'
import { useAppDispatch } from '../redux/hook';
import { updateFormData as UpdateStepStartFormData } from '../redux/slices/application-start-slice';
import { updateFormData as UpdateStep1FormData } from '../redux/slices/application-step-1-slice';
import { updateFormData as UpdateStep2FormData } from '../redux/slices/application-step-2-slice';
import { updateFormData as UpdateStep3FormData } from '../redux/slices/application-step-3-slice';
import { updateFormData as UpdateStep4FormData } from '../redux/slices/application-step-4-slice';
import { updateFormData as UpdateStep5FormData } from '../redux/slices/application-step-5-slice';
import { MapDraft } from '../models/classes/MapDraft.class';
import { Properties, SMSInfo } from '../models/polymer/Properties.model';

export const useMapDraft = () => {
  const AppDispatch = useAppDispatch();

  const performDraftMapping = useCallback((draftData: any, mapStartApplication: boolean = true, smsInfo?: SMSInfo, property?: Properties, hasOutstandingLoan?: boolean)=> {
    let obj = new MapDraft(draftData);
    if(mapStartApplication){
      AppDispatch(UpdateStepStartFormData(obj.generateStepStartMapping()))
    }
    else{
      AppDispatch(UpdateStepStartFormData(obj.generateWithSmsStepStartMapping(smsInfo!, property, hasOutstandingLoan))) //Assign SMSInfo to map start application
    }
    console.log("obj.generateStep1Mapping()",obj.generateStep1Mapping(property))
    AppDispatch(UpdateStep1FormData(obj.generateStep1Mapping(property)))
    AppDispatch(UpdateStep2FormData(obj.generateStep2MappingWithSmsInfo(smsInfo!)))
    AppDispatch(UpdateStep3FormData(obj.generateStep3Mapping()))
    AppDispatch(UpdateStep4FormData(obj.generateStep4Mapping()))
    AppDispatch(UpdateStep5FormData(obj.generateStep5Mapping()))
  }, [AppDispatch])



  const generatedDraftObj = useCallback((draftData:any)=>{
    let obj = new MapDraft(draftData);
    return {
      applicationStart: obj.generateStepStartMapping(), 
      applicationStep1: obj.generateStep1Mapping(), 
      applicationStep2: obj.generateStep2Mapping(), 
      applicationStep3: obj.generateStep3Mapping(), 
      applicationStep4: obj.generateStep4Mapping(), 
      applicationStep5: obj.generateStep5Mapping(),
    }
  },[])

  return { performDraftMapping, generatedDraftObj }
  
}